/**
 * Partidas
 *
 */
import React from 'react'
import { Table, Divider, Input, InputNumber, message, Button, Tooltip } from 'antd'
import { Cell, Crud } from '../../../components'
import Api from '../../../Api'
import Exception from '../../../Exception'
import _ from 'lodash'
import numeral from 'numeral'

/**
 *
 * @param {number} solPagoId
 * @param {string} search
 * @returns
 */
function queryPartidas(solPagoId, search) {
  const filter = {}

  if (search && search.length > 0) {
    filter.sDescripcion = { $like: `%${search}%`}
  }

  return Api.query.list({
    maestro: {
      __returnType: 'one',
      model: 'SubOrdenPago',
      attributes: [
        'iId',
        'sEstado',
      ],
      where: { iId: solPagoId },
    },

    conceptos: {
      model: 'SubOrdenesPagoOtrosCargos',
      attributes: [
        'iId',
        'dMonto',
        'sDescripcion',
        ['sDescripcion', 'sAnterior'],
        ['dMonto', 'dAnterior'],
      ],
      where: {
        ...filter,
        iIdSubOrdenPago: solPagoId,
        iActivo: true,
      }
    }
  })
}

/**
 *
 * @param {number} id
 * @param {any} values
 * @returns
 */
function setOtrosCargosItemValues (id, values) {
  const payload = {
    model: 'SubOrdenesPagoOtrosCargos',
    id,
    values,
  }

  return Api.post('/kernel/mutator', payload)
}

/**
 *
 * @param {{ subContratoId: number, solicitudPagoId: number }} props
 * @returns
 */
export function SubOrdenPagoOtrosCargosTable(props) {
  const [loading, setLoading] = React.useState(false)
  const [master, setMaster] = React.useState()
  const [records, setRecords] = React.useState([])
  const [searchText, setSearch] = React.useState()
  const masterIsPending = _.get(master, 'sEstado') === 'ELABORANDO'
  const renderCurrency = val => numeral(val).format('$0,0.00')

  /**
   *
   * @param {string} id
   * @param {string | number} new_val
   */
  const setRecordValue = (id, key, new_val) => {
    setRecords(data => {
      const new_data = data.map(i => {
        if (i.iId.toString() !== id) { return i }
        const new_i = JSON.parse(JSON.stringify(i))
        _.set(new_i, key, new_val)
        return new_i
      })

      return new_data
    })
  }

  /**
   *
   * @param {string} target_id
   * @param {number} new_val
   */
  const onRecordValueChange = (target_id, new_desc, new_val) => {
    const item = records.find(i => i.iId.toString() === target_id.toString())
    const desc_diff = item.sAnterior !== new_desc
    const monto_diff = (+item.dAnterior) !== (+new_val)

    if ((!monto_diff) && (!desc_diff)) {
      return
    }

    const payload = {}
    if (desc_diff && new_desc) { payload.sDescripcion = new_desc }
    if (monto_diff && typeof new_val === 'number') { payload.dMonto = +new_val }

    setLoading(false)
    setOtrosCargosItemValues(target_id, payload)
      .then(() => {
        setRecords(data => {
          const new_data = data.map(i => {
            if (i.iId.toString() !== target_id) { return i }
            const new_i = JSON.parse(JSON.stringify(i))

            if (desc_diff && typeof new_desc === 'string') { _.set(new_i, 'sAnterior', new_desc)}
            if (monto_diff && typeof new_val === 'number') {_.set(new_i, 'dAnterior', new_val) }

            return new_i
          })

          return new_data
        })
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        Exception.load(e).show()
      })
  }

  /**
   * agregar
   *
   */
  const agregar = () => {
    const payload = { iIdSubOrdenPago: props.solicitudPagoId, sDescripcion: '<DESCRIPCIÓN DEL CONCEPTO>', dMonto: 0 }
    setOtrosCargosItemValues(null, payload)
      .then(r => {
        setLoading(false)
        setRecords(data => data.concat([r.data.record]))
      })
      .catch(e => {
        setLoading(false)
        Exception.load(e).show()
      })
  }

  /**
   * fetch
   *
   * @param {string} search
   */
   const fetch = (solicitudPagoId, search) => {
    queryPartidas(solicitudPagoId, search)
      .then(res => {
        setLoading(false)
        setMaster(res.data.maestro)
        setRecords(res.data.conceptos)
        setSearch(search)
      })
      .catch(e => {
        setLoading(false)
        Exception.load(e).show()
      })
  }

  /**
   * remove
   *
   * @param {number} id
   */
  const remove = (id) => {
    setLoading(true)
    setOtrosCargosItemValues(id, { iActivo: false })
      .then(() => {
        message.success('Eliminado')
        setRecords(data => data.filter(i => i.iId.toString() !== id.toString()))
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        Exception.load(error).show()
      })
  }

  /**
   * columns
   *
   */
  const columns = Cell.buildList([
    { title: 'NOMBRE', dataIndex: 'sDescripcion', width: 300, render: !masterIsPending ? undefined : (val, r) => (
      <Input
        size='small'
        value={val}
        placeholder='DESCRIPCIÓN DEL CONCEPTO'
        style={{ marginRight: 10 }}
        onChange={e => setRecordValue(r.iId.toString(), 'sDescripcion', e.target.value.toString().toUpperCase())}
      />
    )},
    { title: 'MONTO', dataIndex: 'dMonto', width: 100, render: !masterIsPending ? renderCurrency : (val, r) => (
      <InputNumber
        size='small'
        value={val}
        defaultValue={val}
        disabled={!masterIsPending}
        onChange={new_val => setRecordValue(r.iId.toString(), 'dMonto', new_val)}
        style={{ width: '100%' }}
      />
    )},
  ].concat(!masterIsPending ? [] : [
    {
      title: 'ACCIONES', dataIndex: 'sDescripcion', width: 70,
      render: (_, r) => (
        <div>
          <Tooltip title='Guardar'>
            <Button
              icon='check'
              size='small'
              loading={loading}
              onClick={() => onRecordValueChange(r.iId.toString(), r.sDescripcion, r.dMonto)}
              disabled={(!masterIsPending) || loading || (r.sDescripcion === r.sAnterior && (+r.dMonto) === (+r.dAnterior))}
              style={{ marginLeft: 5, marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title='¿Eliminar?'>
            <Button
              size='small'
              icon='delete'
              loading={loading}
              disabled={(!masterIsPending) || loading}
              onClick={() => remove(r.iId)}
            />
          </Tooltip>
        </div>
      )
    }
  ]))

  /**
   * onLoad
   *
   */
  React.useEffect(() => {
    if (props.solicitudPagoId) {
      fetch(props.solicitudPagoId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.solicitudPagoId])

  const crud = (
    <Crud
      buttons={[].concat(masterIsPending ? ['add'] : []).concat(['reload'])}
      onReload={() => fetch(props.solicitudPagoId, searchText)}
      onAdd={() => agregar()}
    />
  )

  const tableTitle = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {crud}
      <Divider type='vertical'/>
      <Input.Search
        placeholder='Buscar'
        style={{ width: 185 }}
        onSearch={value => fetch(master ? master.iId : -2, value)}
        allowClear
      />
    </div>
  )

  return (
    <Table
      rowKey='iId'
      size='small'
      rowClassName='row-pure'
      pagination={false}
      bordered={false}
      dataSource={records}
      columns={columns}
      loading={loading}
      title={() => tableTitle}
      style={props.style}
    />
  )
}
